var clone = require('clone');

module.exports = function(options, defaults) {
  options = options || {};

  Object.keys(defaults).forEach(function(key) {
    if (typeof options[key] === 'undefined') {
      options[key] = clone(defaults[key]);
    }
  });

  return options;
};


//////////////////
// WEBPACK FOOTER
// ./~/defaults/index.js
// module id = 716
// module chunks = 1